import { useCallback } from 'react';
import { useStore } from '@xyflow/react';
import { FileInfo } from '../../services/lambdaService';

/**
 * Returns true if this node has at least one incoming edge.
 */
export function useHasUpstreamEdge(nodeId: string): boolean {
  return useStore(
    useCallback(
      (state: any) => state.edges.some((e: any) => e.target === nodeId),
      [nodeId]
    )
  );
}

/**
 * Traverses ReactFlow edges upstream from the given node to find the nearest
 * connected node that has a selectedFile in its data.
 */
export function useUpstreamFile(nodeId: string): FileInfo | null {
  const selector = useCallback(
    (state: any) => {
      const visited = new Set<string>();
      const queue = [nodeId];

      while (queue.length > 0) {
        const currentId = queue.shift()!;
        if (visited.has(currentId)) continue;
        visited.add(currentId);

        for (const edge of state.edges) {
          if (edge.target === currentId) {
            const sourceNode = state.nodes.find((n: any) => n.id === edge.source);
            if (sourceNode?.data?.selectedFile) {
              return sourceNode.data.selectedFile as FileInfo;
            }
            queue.push(edge.source);
          }
        }
      }

      return null;
    },
    [nodeId]
  );

  return useStore(selector);
}
